import IconBase from "./IconBase";

const FitFrameIcon = props => (
  <IconBase data-testid="FitFrameIcon" {...props}>
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      d="m12 8 4-4m-8 8-4 4m9-13h4v4m-6 10h4a2 2 0 0 0 2-2v-4M7 17H3v-4M9 3H5a2 2 0 0 0-2 2v4"
    />
  </IconBase>
);

export default FitFrameIcon;
